// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import EventVolumeChartController from "./charts/event_volume_chart_controller"
application.register("charts--event-volume-chart", EventVolumeChartController)

import PerformanceChartController from "./charts/performance_chart_controller"
application.register("charts--performance-chart", PerformanceChartController)

import QualityChartController from "./charts/quality_chart_controller"
application.register("charts--quality-chart", QualityChartController)